import http from '../_http_v2';

const setting = {
  custom: (m) => { return http.get(`console/setting/setting/custom`, m); }
}

export default setting

export { setting }